/**
 * Nicknames (owner, 2026-10-26): a player's own label for a friend ("LIZA"), so the random
 * two-word names say who is who. Private: kept in this player's save (and save codes), never sent
 * to the server, so a typed word is fine where names are otherwise only picked from lists.
 */

/** The longest nickname, in characters (it fits where a two-word name does, and more). */
export const NICKNAME_MAX = 10;

/** The characters a nickname may hold (besides spaces): what the pixel font draws. */
export const NICKNAME_KEYS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

/**
 * A nickname as kept: capitals, digits and single spaces, trimmed, at most {@link NICKNAME_MAX}
 * characters. '' means none.
 */
export function cleanNickname(raw: string): string {
  return raw
    .toUpperCase()
    .replace(/[^A-Z0-9 ]/g, '')
    .replace(/ +/g, ' ')
    .trim()
    .slice(0, NICKNAME_MAX)
    .trim();
}

/** Nicknames by player id, with any that are not a kept nickname (or are empty) left out. */
export function cleanNicknames(
  raw: Readonly<Record<string, string>> | undefined,
): Record<string, string> {
  const out: Record<string, string> = {};
  for (const [player, nickname] of Object.entries(raw ?? {})) {
    const clean = typeof nickname === 'string' ? cleanNickname(nickname) : '';
    if (clean && clean === nickname) out[player] = clean;
  }
  return out;
}
